import React from 'react'
import PropTypes from 'prop-types'
import { TextField } from 'components/Form'
import { parsePhoneNumber, isPossiblePhone } from '../../utils/phone'

const MobileOrEmail = ({ onChange, value, ...props }) => {
  const inputRef = React.useRef()

  const handleChange = input => {
    let formattedInput = undefined
    if (input.length > 0) {
      if (isPossiblePhone(input)) {
        formattedInput = parsePhoneNumber(input)
      } else {
        formattedInput = input
      }
    }

    onChange({ target: { id: props.id, value: formattedInput } })
  }

  return <TextField {...props} value={value} onChange={event => handleChange(event.target.value)} innerRef={inputRef} />
}

MobileOrEmail.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default MobileOrEmail



// WEBPACK FOOTER //
// ./src/components/MobileOrEmail/index.js